import React, { useEffect, useState } from 'react';
import { CalendarIcon, Clock, X } from "lucide-react";
import { format } from "date-fns";
import authService from '../../../Services/authService';

export default function DateSlotModal({ isOpen, onClose, onConfirm }) {
  const [step, setStep] = useState("date");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [appointmentData, setAppointmentData] = useState([]);
  const token = authService.getCurrentUsertoken();

  useEffect(() => {
    if (isOpen) {
      loadTimeSlots();
    }
  }, [isOpen]);

  const loadTimeSlots = () => {
    const url = new URL(authService.getApiUrl() + 'currentweekslots');
    fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        organization_id: 1
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        // if (res.status === 401) {
        //   authService.clientlogout();
        //   window.location.href = "/login";
        // } else {
           return res.json();
        // }
      })
      .then((result) => {
        if (result && result.data) {
          setAppointmentData(result.data);
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const handleDateSelect = (date) => {
    setSelectedDate(date);
    setSelectedSlot(null);
    setStep("slot");
  };

  const handleSlotSelect = (slot) => {
    setSelectedSlot(slot);
  };

  const handleConfirm = () => {
    if (selectedDate && selectedSlot) {
      onConfirm(selectedDate, selectedSlot);
      onClose();
      authService.AppointmentSlotsSetup(selectedDate.toISOString(), selectedSlot);
    }
  };

  const handleBack = () => {
    setStep("date");
    setSelectedSlot(null);
  };

  if (!isOpen) return null;

  // Extract available dates
  const availableDates = appointmentData.map(item => new Date(item.date));

  // Get slots for the selected date
  const selectedDateStr = selectedDate ? format(selectedDate, "yyyy-MM-dd") : null;
  const selectedDateSlots = appointmentData.find(item => item.date === selectedDateStr)?.times || [];

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-md w-full max-h-[90vh] overflow-auto">
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b border-[#E0E0E0]">
          <h2 className="text-lg font-medium text-[#4A4A4A]">
            {step === "date" ? "Select Date" : "Select Time Slot"}
          </h2>
          <button onClick={onClose} className="text-[#4A4A4A] hover:text-[#951C25]">
            <X size={20} />
          </button>
        </div>

        {/* Content */}
        <div className="p-4">
          {step === "date" ? (
            <div className="grid grid-cols-3 gap-3">
              {availableDates.map((date, index) => (
                <button
                  key={index}
                  onClick={() => handleDateSelect(date)}
                  className={`p-3 rounded-lg border ${selectedDate && format(date, "yyyy-MM-dd") === selectedDateStr
                      ? "border-[#951C25] bg-[#951C25]/5"
                      : "border-[#E0E0E0] hover:border-[#951C25]/50"
                    }`}
                >
                  <div className="text-xs text-[#4A4A4A]/70">{format(date, "EEE")}</div>
                  <div className="text-lg font-medium text-[#4A4A4A]">{format(date, "d")}</div>
                  <div className="text-xs text-[#4A4A4A]/70">{format(date, "MMM")}</div>
                </button>
              ))}
            </div>
          ) : (
            <div>
              <div className="mb-4">
                <div className="flex items-center mb-2">
                  <CalendarIcon size={16} className="text-[#951C25] mr-2" />
                  <span className="text-sm font-medium text-[#4A4A4A]">
                    {selectedDate ? format(selectedDate, "EEEE, MMM d, yyyy") : "Select a date"}
                  </span>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3">
                {selectedDateSlots.map((slot, index) => (
                  <button
                    key={index}
                    onClick={() => !slot.disabled && handleSlotSelect(slot.time)}
                    disabled={slot.disabled}
                    className={`p-3 rounded-lg border flex items-center justify-center 
                      ${slot.disabled ? "cursor-not-allowed opacity-50" : ""}
                      ${selectedSlot === slot.time
                        ? "border-[#951C25] bg-[#951C25]/5"
                        : "border-[#E0E0E0] hover:border-[#951C25]/50"}
                    `}
                  >
                    <Clock size={14} className="text-[#951C25] mr-2" />
                    <span className="text-sm text-[#4A4A4A]">{slot.time}</span>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="p-4 border-t border-[#E0E0E0] flex justify-between">
          {step === "slot" ? (
            <button
              onClick={handleBack}
              className="px-4 py-2 border border-[#E0E0E0] rounded-md text-sm text-[#4A4A4A]"
            >
              Back
            </button>
          ) : (
            <div></div>
          )}
          <button
            onClick={handleConfirm}
            disabled={step === "date" || !selectedSlot}
            className={`px-4 py-2 rounded-md text-sm text-white ${step === "date" || !selectedSlot
                ? "bg-[#951C25]/50 cursor-not-allowed"
                : "bg-[#951C25] hover:bg-[#951C25]/90"
              }`}
          >
            Confirm Appointment
          </button>
        </div>
      </div>
    </div>
  );
}
